var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrgSeats(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6658 5.91145C19.6658 7.83651 18.1052 9.39709 16.1801 9.39709C14.2551 9.39709 12.6945 7.83651 12.6945 5.91145C12.6945 3.98639 14.2551 2.42581 16.1801 2.42581C18.1052 2.42581 19.6658 3.98639 19.6658 5.91145ZM22.0916 5.91145C22.0916 9.17625 19.4449 11.8229 16.1801 11.8229C15.0858 11.8229 14.061 11.5256 13.182 11.0073L9.38713 14.8246L12.7941 18.2736C13.2649 18.7502 13.2601 19.5181 12.7836 19.9889C12.307 20.4596 11.5391 20.4549 11.0683 19.9784L7.68261 16.5509L5.56196 18.7129L8.6989 21.942C9.16567 22.4224 9.15456 23.1903 8.67409 23.6571C8.19362 24.1239 7.42573 24.1127 6.95896 23.6323L3.8628 20.4452L2.0788 22.264C1.60973 22.7422 0.841798 22.7497 0.363576 22.2806C-0.114646 21.8115 -0.122064 21.0436 0.347009 20.5654L6.81936 13.9668L11.387 9.37214C10.6834 8.39932 10.2687 7.20382 10.2687 5.91145C10.2687 2.64665 12.9153 0 16.1801 0C19.4449 0 22.0916 2.64665 22.0916 5.91145Z",
    fill: "#394577"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgSeats);
export default __webpack_public_path__ + "static/media/orgSeats.ff629e6e6e9cf0176e0726c310a52204.svg";
export { ForwardRef as ReactComponent };